import { Modal } from '../../modules/modal.js';

window.app = window.app || {};
app.site = app.site || {};

app.site.navigation = () => {

    const navigation = new Modal({
        modal: document.getElementById('navigation'),
        allowDeeplinking: true,
        allowHistory: false,
        startsOpen: false,
        on: {
            ready: (modal, instance) => {
                modal.querySelector('button#close')?.addEventListener('click', () => instance.close());
            }
        }
    });

    const primary       = document.querySelector('dialog#navigation div#primary');
    if (!primary) return;
    const primaryItems  = primary.querySelectorAll('ul.first-level > li > a');
    const primaryPanels = primary.querySelectorAll('div.second-level > div.nav-level-items > div');
    const primaryBack   = primary.querySelector('div.second-level > div.nav-level-control > button');

    const clickHandler = (event) => {
        const li = event.target.closest('li');
        if (li.matches('.has-items')) {
            if (!li.matches('.is-active')) {
                event.preventDefault();
                setActive(-1);
                const index = [...li.parentNode.children].indexOf(li);
                setActive(index);
            }
        }
    };

    const setActive = (index) => {
        if (index === -1) {
            primary.classList.remove('is-open');
            primary.querySelectorAll('.is-active').forEach(i => i.classList.remove('is-active'));
        } else {
            primaryItems[index].parentNode.classList.add('is-active');
            primaryPanels[index].classList.add('is-active');
            primary.classList.add('is-open');
        }
    };

    primaryItems.forEach(i => i.addEventListener('click', clickHandler, true));
    primaryBack.addEventListener('click', (event) => {
        event.preventDefault();
        setActive(-1);
    }, true);
};